import React from 'react';
import { HighlightsPanel } from './components/HighlightsPanel/HighlightsPanel';
import { loan } from './data/loan';
interface AppProps {
  statusRules?: boolean;
}
export function App({
  statusRules = true
}: AppProps) {
  return <main className="min-h-full w-full bg-[#eef3fb] p-3.5" data-id="element-0" data-mp="3k92om18wo2mb">
      <HighlightsPanel loan={loan} rulesEnabled={statusRules} data-id="element-1" data-mp="3f9yhdg5jkeym" />
    </main>;
}